import { Text } from '@components/primitives';
import MaterialIcons from '@expo/vector-icons/MaterialIcons';
import { useToast } from '@hooks';
import colors from '@theme/colors';
import { scale } from '@utils/normalize';
import { showSuccessToast } from '@utils/toastManager';
import * as Clipboard from 'expo-clipboard';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Pressable, View } from 'react-native';
import styles from './style';

type TokenContainerProps = {
  title: string;
  token?: string;
};

const TokenContainer = ({ title, token = '' }: TokenContainerProps): JSX.Element | null => {
  const toast = useToast();
  const { t } = useTranslation('common');

  if (token) {
    return (
      <Pressable
        testID="tokenContainerBtn"
        onPress={() => {
          Clipboard.setStringAsync(token);
          showSuccessToast(toast, t('transactionDetailsScreen.kodeVoucherTersalin'), 'tokenContainerBtn');
        }}
        style={styles.container}>
        <View style={styles.textContainer}>
          <Text variant="xsm-normal">{title}</Text>
          <Text variant="sm-bold" style={styles.tokenStyle}>
            {token}
          </Text>
        </View>
        <MaterialIcons name="file-copy" size={scale(24)} color={colors.secondary.orchid} />
      </Pressable>
    );
  }
  return null;
};

TokenContainer.defaultProps = {
  token: '',
};

export default TokenContainer;
